/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_N8n_Use_1_TermInputs */

const en_svc_n8n_use_1_term = /** @type {(inputs: Svc_N8n_Use_1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orders and invoices`)
};

const lv_svc_n8n_use_1_term = /** @type {(inputs: Svc_N8n_Use_1_TermInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasūtījumi un rēķini`)
};

/**
* | output |
* | --- |
* | "Orders and invoices" |
*
* @param {Svc_N8n_Use_1_TermInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_n8n_use_1_term = /** @type {((inputs?: Svc_N8n_Use_1_TermInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_N8n_Use_1_TermInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_n8n_use_1_term(inputs)
	return en_svc_n8n_use_1_term(inputs)
});